export default {
	meta: { auth: true },
	children: {
		front: {
			path: "/",
			alias: "/index.html",
			meta: { bcText: "Home" },
			component: () => import(
				/* webpackChunkName: "Front" */
				"@/pages/Front"
			),
			children: {
				company: {
					path: "/company",
					meta: { bcText: "Company" },
					component: () => import(
						/* webpackChunkName: "Company" */
						"@/pages/Front/Company"
					),
					children: {
						bonus: {
							path: "/company/bonus",
							meta: {
								auth: "read_bonus",
								bcText: "Bonus"
							},
							component: () => import(
								/* webpackChunkName: "BonusIndex" */
								"@/pages/Front/Company/Bonus"
							),
							children: {
								bonusEdit: {
									path: "/company/bonus/edit",
									meta: {
										auth: "edit_bonus",
										bcText: "Edit Bonus"
									},
									component: () => import(
										/* webpackChunkName: "Bonus" */
										"@/pages/Front/Company/Bonus/Bonus"
									)
								}
							}
						},

						facilityMaintenance: {
							path: "/company/facility-maintenance",
							meta: {
								bcText: "Facility Maintenance"
							},
							component: () => import(
								/* webpackChunkName: "FacilityMaintenance" */
								"@/pages/Front/Company/FacilityMaintenance"
							),
							children: {
								facilityMaintenanceContacts: {
									path: "/company/facility-maintenance/contacts",
									meta: {
										auth: "browse_facility_maintenance_contacts",
										bcText: "Contacts"
									},
									component: () => import(
										/* webpackChunkName: "FacilityMaintenanceContacts" */
										"@/pages/Front/Company/FacilityMaintenance/Contacts"
									),
									children: {
										facilityMaintenanceContactAdd: {
											path: "/company/facility-maintenance/contacts/add",
											meta: {
												auth: "add_facility_maintenance_contacts",
												bcText: "Add Contact"
											},
											component: () => import(
												/* webpackChunkName: "FacilityMaintenanceContact" */
												"@/pages/Front/Company/FacilityMaintenance/Contacts/Contact"
											)
										},

										facilityMaintenanceContact: {
											path: "/company/facility-maintenance/contacts/:idContact",
											props: route => ( { idContact: parseInt( route.params.idContact ) } ),
											meta: {
												auth: [
													"read_facility_maintenance_contacts",
													"edit_facility_maintenance_contacts"
												],
												bcFetch: params => ( {
													id: params.idContact,
													property: "name",
													route: "facilityMaintenanceContact"
												} ),
												bcText: contact => contact.name
											},
											component: () => import(
												/* webpackChunkName: "FacilityMaintenanceContact" */
												"@/pages/Front/Company/FacilityMaintenance/Contacts/Contact"
											)
										}
									}
								},

								facilityMaintenanceVendors: {
									path: "/company/facility-maintenance/vendors",
									meta: {
										auth: "browse_facility_maintenance_vendors",
										bcText: "Vendors"
									},
									component: () => import(
										/* webpackChunkName: "FacilityMaintenanceVendors" */
										"@/pages/Front/Company/FacilityMaintenance/Vendors"
									),
									children: {
										facilityMaintenanceVendorAdd: {
											path: "/company/facility-maintenance/vendors/add",
											meta: {
												auth: "add_facility_maintenance_vendors",
												bcText: "Add Vendor"
											},
											component: () => import(
												/* webpackChunkName: "FacilityMaintenanceVendor" */
												"@/pages/Front/Company/FacilityMaintenance/Vendors/Vendor"
											)
										},

										facilityMaintenanceVendor: {
											path: "/company/facility-maintenance/vendors/:idVendor",
											props: route => ( { idVendor: parseInt( route.params.idVendor ) } ),
											meta: {
												auth: [
													"read_facility_maintenance_vendors",
													"edit_facility_maintenance_vendors"
												],
												bcFetch: params => ( {
													id: params.idVendor,
													property: "name",
													route: "facilityMaintenanceVendor"
												} ),
												bcText: vendor => vendor.name
											},
											component: () => import(
												/* webpackChunkName: "FacilityMaintenanceVendor" */
												"@/pages/Front/Company/FacilityMaintenance/Vendors/Vendor"
											)
										}
									}
								},

								facilityMaintenanceVendorTypes: {
									path: "/company/facility-maintenance/vendor-categories",
									meta: {
										auth: "browse_facility_maintenance_vendor_types",
										bcText: "Vendor Categories"
									},
									component: () => import(
										/* webpackChunkName: "FacilityMaintenanceVendorTypes" */
										"@/pages/Front/Company/FacilityMaintenance/VendorTypes"
									),
									children: {
										facilityMaintenanceVendorTypeAdd: {
											path: "/company/facility-maintenance/vendor-categories/add",
											meta: {
												auth: "add_facility_maintenance_vendor_types",
												bcText: "Add Vendor Category"
											},
											component: () => import(
												/* webpackChunkName: "FacilityMaintenanceVendorType" */
												"@/pages/Front/Company/FacilityMaintenance/VendorTypes/VendorType"
											)
										},

										facilityMaintenanceVendorType: {
											path: "/company/facility-maintenance/vendor-categories/:idVendorType",
											props: route => ( { idVendorType: parseInt( route.params.idVendorType ) } ),
											meta: {
												auth: [
													"read_facility_maintenance_vendor_types",
													"edit_facility_maintenance_vendor_types"
												],
												bcFetch: params => ( {
													id: params.idVendorType,
													property: "name",
													route: "facilityMaintenanceVendorType"
												} ),
												bcText: vendor => vendor.name
											},
											component: () => import(
												/* webpackChunkName: "FacilityMaintenanceVendorType" */
												"@/pages/Front/Company/FacilityMaintenance/VendorTypes/VendorType"
											)
										}
									}
								},

								facilityMaintenanceWorkOrders: {
									path: "/company/facility-maintenance/work-orders",
									meta: {
										auth: "browse_facility_maintenance_work_orders",
										bcText: "Work Orders"
									},
									component: () => import(
										/* webpackChunkName: "FacilityMaintenanceWorkOrders" */
										"@/pages/Front/Company/FacilityMaintenance/WorkOrders"
									),
									children: {
										facilityMaintenanceCompletedWorkOrders: {
											path: "/company/facility-maintenance/work-orders/completed",
											meta: {
												auth: "browse_facility_maintenance_work_orders",
												bcText: "Completed"
											},
											component: () => import(
												/* webpackChunkName: "FacilityMaintenanceCompletedWorkOrders" */
												"@/pages/Front/Company/FacilityMaintenance/WorkOrders/Completed"
											)
										},

										facilityMaintenanceWorkOrderAdd: {
											path: "/company/facility-maintenance/work-orders/add",
											meta: {
												auth: "add_facility_maintenance_work_orders",
												bcText: "Add Work Order"
											},
											component: () => import(
												/* webpackChunkName: "FacilityMaintenanceWorkOrder" */
												"@/pages/Front/Company/FacilityMaintenance/WorkOrders/WorkOrder"
											)
										},

										facilityMaintenanceWorkOrderRequest: {
											path: "/company/facility-maintenance/work-orders/request",
											meta: {
												auth: "read_facility_maintenance_work_orders",
												bcText: "Request a Work Order"
											},
											component: () => import(
												/* webpackChunkName: "FacilityMaintenanceWorkOrder" */
												"@/pages/Front/Company/FacilityMaintenance/WorkOrders/WorkOrder"
											)
										},

										facilityMaintenanceWorkOrderRequests: {
											path: "/company/facility-maintenance/work-orders/requests",
											meta: {
												auth: "add_facility_maintenance_work_orders",
												bcText: "Work Order Requests"
											},
											component: () => import(
												/* webpackChunkName: "FacilityMaintenanceWorkOrderRequests" */
												"@/pages/Front/Company/FacilityMaintenance/WorkOrders/Requests"
											)
										},

										facilityMaintenanceWorkOrder: {
											path: "/company/facility-maintenance/work-orders/:idWorkOrder",
											props: route => ( { idWorkOrder: parseInt( route.params.idWorkOrder ) } ),
											meta: {
												auth: [
													"read_facility_maintenance_work_orders",
													"edit_facility_maintenance_work_orders"
												],
												bcText: "View Work Order"
											},
											component: () => import(
												/* webpackChunkName: "FacilityMaintenanceWorkOrder" */
												"@/pages/Front/Company/FacilityMaintenance/WorkOrders/WorkOrder"
											)
										}
									}
								}
							}
						},

						locations: {
							path: "/company/locations",
							meta: {
								auth: "browse_locations",
								bcText: "Locations"
							},
							component: () => import(
								/* webpackChunkName: "Locations" */
								"@/pages/Front/Company/Locations"
							),
							children: {
								locationAdd: {
									path: "/company/locations/add",
									meta: {
										auth: "add_locations",
										bcText: "Add a Location"
									},
									component: () => import(
										/* webpackChunkName: "Location" */
										"@/pages/Front/Company/Locations/Location"
									)
								},

								location: {
									path: "/company/locations/:idLocation",
									props: route => ( { idLocation: parseInt( route.params.idLocation ) } ),
									meta: {
										auth: [
											"read_locations",
											"edit_locations"
										],
										bcFetch: params => ( {
											id: params.idLocation,
											property: "name",
											route: "location"
										} ),
										bcText: location => location.name
									},
									component: () => import(
										/* webpackChunkName: "Location" */
										"@/pages/Front/Company/Locations/Location"
									)
								}
							}
						},

						thirdPartyServices: {
							path: "/company/3rd-party-services",
							meta: {
								auth: "browse_third_party_services",
								bcText: "3rd Party Services"
							},
							component: () => import(
								/* webpackChunkName: "ThirdPartyServices" */
								"@/pages/Front/Company/ThirdPartyServices"
							),
							children: {
								thirdPartyServiceAdd: {
									path: "/company/3rd-party-services/add",
									meta: {
										auth: "add_third_party_services",
										bcText: "Add a 3rd Party Service"
									},
									component: () => import(
										/* webpackChunkName: "ThirdPartyService" */
										"@/pages/Front/Company/ThirdPartyServices/ThirdPartyService"
									)
								},

								thirdPartyService: {
									path: "/company/3rd-party-services/:idThirdPartyService",
									props: route => ( { idThirdPartyService: parseInt( route.params.idThirdPartyService ) } ),
									meta: {
										auth: [
											"read_third_party_services",
											"edit_third_party_services"
										],
										bcFetch: params => ( {
											id: params.idThirdPartyService,
											property: "name",
											route: "thirdPartyService"
										} ),
										bcText: thirdPartyService => thirdPartyService.name
									},
									component: () => import(
										/* webpackChunkName: "ThirdPartyService" */
										"@/pages/Front/Company/ThirdPartyServices/ThirdPartyService"
									)
								}
							}
						},

						vto: {
							path: "/company/vto",
							meta: {
								auth: "read_vto",
								bcText: "Vision / Traction Organizer"
							},
							component: () => import(
								/* webpackChunkName: "VTOIndex" */
								"@/pages/Front/Company/VTO"
							),
							children: {
								vtoEdit: {
									path: "/company/vto/edit",
									meta: {
										auth: "edit_vto",
										bcText: "Edit VTO"
									},
									component: () => import(
										/* webpackChunkName: "VTO" */
										"@/pages/Front/Company/VTO/VTO"
									)
								}
							}
						}
					}
				},

				pricingHelpList: {
					path: "/pricing-help",
					meta: {
						auth: "browse_pricing_help",
						bcText: "Pricing Help & Logins"
					},
					component: () => import(
						/* webpackChunkName: "PricingHelpList" */
						"@/pages/Front/PricingHelp"
					),
					children: {
						pricingHelpAdd: {
							path: "/pricing-help/add",
							meta: {
								auth: "add_pricing_help",
								bcText: "Add Pricing Help"
							},
							component: () => import(
								/* webpackChunkName: "PricingHelp" */
								"@/pages/Front/PricingHelp/PricingHelp"
							)
						},

						pricingHelp: {
							path: "/pricing-help/:idPricingHelp",
							props: route => ( { idPricingHelp: parseInt( route.params.idPricingHelp ) } ),
							meta: {
								auth: [
									"read_pricing_help",
									"edit_pricing_help"
								],
								bcFetch: params => ( {
									id: params.idPricingHelp,
									property: "name",
									route: "pricingHelp"
								} ),
								bcText: pricingHelp => pricingHelp.name
							},
							component: () => import(
								/* webpackChunkName: "PricingHelp" */
								"@/pages/Front/PricingHelp/PricingHelp"
							)
						}
					}
				},

				calendar: {
					path: "/calendar",
					meta: { bcText: "Calendar" },
					component: () => import(
						/* webpackChunkName: "Calendar" */
						"@/pages/Front/Calendar"
					),
					children: {
						calendarEventAdd: {
							path: "/calendar/add",
							meta: { bcText: "Add to Calendar" },
							component: () => import(
								/* webpackChunkName: "CalendarEvent" */
								"@/pages/Front/Calendar/Event"
							)
						},

						calendarEventEdit: {
							path: "/calendar/:idCalendarEvent",
							props: route => ( { idCalendarEvent: parseInt( route.params.idCalendarEvent ) } ),
							meta: { bcText: "Edit Calendar Event" },
							component: () => import(
								/* webpackChunkName: "CalendarEvent" */
								"@/pages/Front/Calendar/Event"
							)
						}
					}
				},

				apps: {
					path: "/apps",
					meta: { bcText: "Apps" },
					component: () => import(
						/* webpackChunkName: "Apps" */
						"@/pages/Front/Apps"
					),
					children: {
						cubicFeetCalculator: {
							path: "/apps/cubic-feet-calculator",
							meta: { bcText: "Cubic Feet Calculator" },
							component: () => import(
								/* webpackChunkName: "CubicFeetCalculator" */
								"@/pages/Front/Apps/CubicFeetCalculator"
							)
						},

						marginCalculator: {
							path: "/apps/margin-calculator",
							meta: {
								bcText: "Margin Calculator",
								auth: "read_margin_calculator"
							},
							component: () => import(
								/* webpackChunkName: "MarginCalculator" */
								"@/pages/Front/Apps/MarginCalculator"
							)
						},

						sealantCalculator: {
							path: "/apps/sealant-calculator",
							meta: { bcText: "Sealant Calculator" },
							component: () => import(
								/* webpackChunkName: "SealantCalculator" */
								"@/pages/Front/Apps/SealantCalculator"
							)
						}
					}
				},

				account: {
					path: "/account",
					meta: { bcText: "My Account" },
					component: () => import(
						/* webpackChunkName: "Account" */
						"@/pages/Front/Account"
					),
					children: {
						accountSettings: {
							path: "/account/settings",
							meta: { bcText: "Account Settings" },
							component: () => import(
								/* webpackChunkName: "AccountSettings" */
								"@/pages/Front/Account/Settings"
							)
						}
					}
				},

				counterSales: {
					path: "/counter-sales",
					meta: { bcText: "Counter Sales" },
					component: () => import(
						/* webpackChunkName: "CounterSales" */
						"@/pages/Front/CounterSales"
					),
					children: {
						salesLeads: {
							path: "/counter-sales/sales-leads",
							meta: {
								auth: "browse_sales_leads",
								bcText: "Sales Leads"
							},
							component: () => import(
								/* webpackChunkName: "SalesLeads" */
								"@/pages/Front/CounterSales/SalesLeads"
							),
							children: {
								completedSalesLeads: {
									path: "/counter-sales/sales-leads/completed",
									meta: {
										auth: "browse_sales_leads",
										bcText: "Completed"
									},
									component: () => import(
										/* webpackChunkName: "CompletedSalesLeads" */
										"@/pages/Front/CounterSales/SalesLeads/Completed"
									)
								},

								salesLeadAdd: {
									path: "/counter-sales/sales-leads/add",
									meta: {
										auth: "add_sales_leads",
										bcText: "Add a Sales Lead"
									},
									component: () => import(
										/* webpackChunkName: "SalesLead" */
										"@/pages/Front/CounterSales/SalesLeads/SalesLead"
									)
								},

								salesLead: {
									path: "/counter-sales/sales-leads/:idSalesLead",
									props: route => ( { idSalesLead: parseInt( route.params.idSalesLead ) } ),
									meta: {
										auth: [
											"read_sales_leads",
											"edit_sales_leads"
										],
										bcText: "Sales Lead"
									},
									component: () => import(
										/* webpackChunkName: "SalesLead" */
										"@/pages/Front/CounterSales/SalesLeads/SalesLead"
									)
								}
							}
						},

						specSheets: {
							path: "/counter-sales/spec-sheets",
							meta: {
								auth: "browse_spec_sheets",
								bcText: "Spec Sheets"
							},
							component: () => import(
								/* webpackChunkName: "SpecSheets" */
								"@/pages/Front/CounterSales/SpecSheets"
							),
							children: {
								specSheetAdd: {
									path: "/counter-sales/spec-sheets/add",
									meta: {
										auth: "add_spec_sheets",
										bcText: "Add a Spec Sheet"
									},
									component: () => import(
										/* webpackChunkName: "SpecSheet" */
										"@/pages/Front/CounterSales/SpecSheets/SpecSheet"
									)
								},

								specSheet: {
									path: "/counter-sales/spec-sheets/:idSpecSheet",
									props: route => ( { idSpecSheet: parseInt( route.params.idSpecSheet ) } ),
									meta: {
										auth: [
											"read_spec_sheets",
											"edit_spec_sheets"
										],
										bcText: "Spec Sheet"
									},
									component: () => import(
										/* webpackChunkName: "SpecSheet" */
										"@/pages/Front/CounterSales/SpecSheets/SpecSheet"
									)
								}
							}
						}
					}
				},

				outsideSales: {
					path: "/outside-sales",
					meta: { bcText: "Outside Sales" },
					component: () => import(
						/* webpackChunkName: "OutsideSales" */
						"@/pages/Front/OutsideSales"
					),
					children: {
						customers: {
							path: "/outside-sales/customers",
							meta: {
								auth: "browse_customers",
								bcText: "Customers"
							},
							component: () => import(
								/* webpackChunkName: "Customers" */
								"@/pages/Front/OutsideSales/Customers"
							),
							children: {
								customerAdd: {
									path: "/outside-sales/customers/add",
									meta: {
										auth: "add_customers",
										bcText: "Add a Customer"
									},
									component: () => import(
										/* webpackChunkName: "Customer" */
										"@/pages/Front/OutsideSales/Customers/Customer"
									)
								},

								customer: {
									path: "/outside-sales/customers/:idCustomer",
									props: route => ( { idCustomer: parseInt( route.params.idCustomer ) } ),
									meta: {
										auth: [
											"read_customers",
											"edit_customers"
										],
										bcFetch: params => ( {
											id: params.idCustomer,
											property: "name",
											route: "customer"
										} ),
										bcText: customer => customer.name
									},
									component: () => import(
										/* webpackChunkName: "Customer" */
										"@/pages/Front/OutsideSales/Customers/Customer"
									),
									children: {
										customerAddressAdd: {
											path: "/outside-sales/customers/:idCustomer/addresses/add",
											meta: {
												auth: "add_addresses",
												bcText: "Add an Address"
											},
											props: route => ( { idCustomer: parseInt( route.params.idCustomer ) } ),
											component: () => import(
												/* webpackChunkName: "CustomerAddress" */
												"@/pages/Front/OutsideSales/Customers/Address"
											)
										},

										customerAddress: {
											path: "/outside-sales/customers/:idCustomer/addresses/:idAddress",
											meta: {
												auth: [
													"read_addresses",
													"edit_addresses"
												],
												bcFetch: params => ( {
													id: params.idAddress,
													property: "alias",
													route: "address"
												} ),
												bcText: address => `Address "${address.alias}"`
											},
											props: route => ( {
												idCustomer: parseInt( route.params.idCustomer ),
												idAddress: parseInt( route.params.idAddress )
											} ),
											component: () => import(
												/* webpackChunkName: "CustomerAddress" */
												"@/pages/Front/OutsideSales/Customers/Address"
											)
										}
									}
								}
							}
						},

						salesmen: {
							path: "/outside-sales/salesmen",
							meta: {
								auth: "browse_salesmen",
								bcText: "Salesmen"
							},
							component: () => import(
								/* webpackChunkName: "Salesmen" */
								"@/pages/Front/OutsideSales/Salesmen"
							),
							children: {
								salesmanAdd: {
									path: "/outside-sales/salesmen/add",
									meta: {
										auth: "add_salesmen",
										bcText: "Add a Salesman"
									},
									component: () => import(
										/* webpackChunkName: "Salesman" */
										"@/pages/Front/OutsideSales/Salesmen/Salesman"
									)
								},

								salesman: {
									path: "/outside-sales/salesmen/:idSalesman",
									props: route => ( { idSalesman: parseInt( route.params.idSalesman ) } ),
									meta: {
										auth: [
											"read_salesmen",
											"edit_salesmen"
										],
										bcFetch: params => ( {
											id: params.idSalesman,
											property: "user.name",
											route: "salesman"
										} ),
										bcText: salesman => salesman.user.name
									},
									component: () => import(
										/* webpackChunkName: "Salesman" */
										"@/pages/Front/OutsideSales/Salesmen/Salesman"
									)
								}
							}
						}
					}
				},

				warehouse: {
					path: "/warehouse",
					meta: { bcText: "Warehouse" },
					component: () => import(
						/* webpackChunkName: "Warehouse" */
						"@/pages/Front/Warehouse"
					),
					children: {
						carriers: {
							path: "/warehouse/carriers",
							meta: {
								auth: "browse_carriers",
								bcText: "Carriers"
							},
							component: () => import(
								/* webpackChunkName: "Carriers" */
								"@/pages/Front/Warehouse/Carriers"
							),
							children: {
								carrierAdd: {
									path: "/warehouse/carriers/add",
									meta: {
										auth: "add_carriers",
										bcText: "Add a Carrier"
									},
									component: () => import(
										/* webpackChunkName: "Carrier" */
										"@/pages/Front/Warehouse/Carriers/Carrier"
									)
								},

								carrier: {
									path: "/warehouse/carriers/:idCarrier",
									props: route => ( { idCarrier: parseInt( route.params.idCarrier ) } ),
									meta: {
										auth: [
											"read_carriers",
											"edit_carriers"
										],
										bcFetch: params => ( {
											id: params.idCarrier,
											property: "name",
											route: "carrier"
										} ),
										bcText: carrier => carrier.name
									},
									component: () => import(
										/* webpackChunkName: "Carrier" */
										"@/pages/Front/Warehouse/Carriers/Carrier"
									)
								}
							}
						},

						outboundFreightList: {
							path: "/warehouse/outbound-freight",
							meta: {
								auth: "browse_outbound_freight",
								bcText: "Outbound Freight"
							},
							component: () => import(
								/* webpackChunkName: "OutboundFreightList" */
								"@/pages/Front/Warehouse/OutboundFreight"
							),
							children: {
								outboundFreightAdd: {
									path: "/warehouse/outbound-freight/add",
									meta: {
										auth: "add_outbound_freight",
										bcText: "Add Outbound Freight"
									},
									component: () => import(
										/* webpackChunkName: "OutboundFreight" */
										"@/pages/Front/Warehouse/OutboundFreight/OutboundFreight"
									)
								},

								outboundFreightRequest: {
									path: "/warehouse/outbound-freight/request",
									meta: {
										auth: "read_outbound_freight",
										bcText: "Request an Outbound Freight"
									},
									component: () => import(
										/* webpackChunkName: "OutboundFreight" */
										"@/pages/Front/Warehouse/OutboundFreight/OutboundFreight"
									)
								},

								outboundFreightRequests: {
									path: "/warehouse/outbound-freight/requests",
									meta: {
										auth: "add_outbound_freight",
										bcText: "Outbound Freight Requests"
									},
									component: () => import(
										/* webpackChunkName: "OutboundFreightRequests" */
										"@/pages/Front/Warehouse/OutboundFreight/Requests"
									)
								},

								outboundFreight: {
									path: "/warehouse/outbound-freight/:idOutboundFreight",
									props: route => ( { idOutboundFreight: parseInt( route.params.idOutboundFreight ) } ),
									meta: {
										auth: [
											"read_outbound_freight",
											"edit_outbound_freight"
										],
										bcText: "Edit Outbound Freight"
									},
									component: () => import(
										/* webpackChunkName: "OutboundFreight" */
										"@/pages/Front/Warehouse/OutboundFreight/OutboundFreight"
									),
									children: {
										outboundFreightErrorAdd: {
											path: "/warehouse/outbound-freight/:idOutboundFreight/errors/add",
											meta: {
												auth: "edit_outbound_freight",
												bcText: "Add an Error"
											},
											props: route => ( { idOutboundFreight: parseInt( route.params.idOutboundFreight ) } ),
											component: () => import(
												/* webpackChunkName: "OutboundFreightError" */
												"@/pages/Front/Warehouse/OutboundFreight/OutboundFreightError"
											)
										}
									}
								}
							}
						},

						warehouseReports: {
							path: "/warehouse/reports",
							meta: {
								auth: "read_warehouse_reports",
								bcText: "Reports"
							},
							component: () => import(
								/* webpackChunkName: "warehouseReports" */
								"@/pages/Front/Warehouse/Reports"
							),
							children: {
								warehouseOutboundFreightReport: {
									path: "/warehouse/reports/outbound-freight",
									meta: { bcText: "Outbound Freight" },
									component: () => import(
										/* webpackChunkName: "warehouseOutboundFreightReport" */
										"@/pages/Front/Warehouse/Reports/OutboundFreight"
									)
								}
							}
						}
					}
				},

				yard: {
					path: "/yard",
					meta: { bcText: "Yard" },
					component: () => import(
						/* webpackChunkName: "Yard" */
						"@/pages/Front/Yard"
					),
					children: {
						yardReports: {
							path: "/yard/reports",
							meta: {
								auth: "read_yard_reports",
								bcText: "Reports"
							},
							component: () => import(
								/* webpackChunkName: "YardReports" */
								"@/pages/Front/Yard/Reports"
							),
							children: {
								yardDeliveryNotesReport: {
									path: "/yard/reports/delivery-notes",
									meta: { bcText: "Delivery Notes" },
									component: () => import(
										/* webpackChunkName: "YardDeliveryNotesReport" */
										"@/pages/Front/Yard/Reports/DeliveryNotes"
									)
								},

								yardDriversReport: {
									path: "/yard/reports/drivers",
									meta: { bcText: "Drivers" },
									component: () => import(
										/* webpackChunkName: "YardDriversReport" */
										"@/pages/Front/Yard/Reports/Drivers"
									)
								},

								yardRentalPickupsReport: {
									path: "/yard/reports/rental-pickups",
									meta: { bcText: "Rental Pickups" },
									component: () => import(
										/* webpackChunkName: "YardRentalPickupsReport" */
										"@/pages/Front/Yard/Reports/RentalPickups"
									)
								},

								yardTrucksReport: {
									path: "/yard/reports/trucks",
									meta: { bcText: "Trucks" },
									component: () => import(
										/* webpackChunkName: "YardTrucksReport" */
										"@/pages/Front/Yard/Reports/Trucks"
									)
								}
							}
						},

						yardTripCostEstimator: {
							path: "/yard/trip-cost-estimator",
							meta: {
								auth: "browse_yard_trips",
								bcText: "Trip Cost Estimator"
							},
							component: () => import(
								/* webpackChunkName: "YardTripCostEstimator" */
								"@/pages/Front/Yard/TripCostEstimator"
							)
						},

						yardDrivers: {
							path: "/yard/drivers",
							meta: {
								auth: "browse_yard_drivers",
								bcText: "Drivers"
							},
							component: () => import(
								/* webpackChunkName: "YardDrivers" */
								"@/pages/Front/Yard/Drivers"
							),
							children: {
								yardDriversTimeOff: {
									path: "/yard/drivers/time-off",
									meta: {
										auth: "edit_yard_drivers",
										bcText: "Time Off"
									},
									component: () => import(
										/* webpackChunkName: "YardDriversTimeOff" */
										"@/pages/Front/Yard/Drivers/DriversTimeOff"
									)
								},

								yardDriverAdd: {
									path: "/yard/drivers/add",
									meta: {
										auth: "add_yard_drivers",
										bcText: "Add a Driver"
									},
									component: () => import(
										/* webpackChunkName: "YardDriver" */
										"@/pages/Front/Yard/Drivers/Driver"
									)
								},

								yardDriver: {
									path: "/yard/drivers/:idDriver",
									props: route => ( { idDriver: parseInt( route.params.idDriver ) } ),
									meta: {
										auth: [
											"read_yard_drivers",
											"edit_yard_drivers"
										],
										bcFetch: params => ( {
											id: params.idDriver,
											property: "user.name",
											route: "driver"
										} ),
										bcText: driver => driver.user.name
									},
									component: () => import(
										/* webpackChunkName: "YardDriver" */
										"@/pages/Front/Yard/Drivers/Driver"
									),
									children: {
										yardDriverTimeOffAdd: {
											path: "/yard/drivers/:idDriver/time-off/add",
											meta: {
												auth: "edit_yard_drivers",
												bcText: "Add Time Off"
											},
											props: route => ( { idDriver: parseInt( route.params.idDriver ) } ),
											component: () => import(
												/* webpackChunkName: "YardDriverTimeOff" */
												"@/pages/Front/Yard/Drivers/DriverTimeOff"
											)
										},

										yardDriverTimeOff: {
											path: "/yard/drivers/:idDriver/time-off/:idTimeOff",
											meta: {
												auth: "edit_yard_drivers",
												bcText: "Time Off"
											},
											props: route => ( {
												idDriver: parseInt( route.params.idDriver ),
												idTimeOff: parseInt( route.params.idTimeOff )
											} ),
											component: () => import(
												/* webpackChunkName: "YardDriverTimeOff" */
												"@/pages/Front/Yard/Drivers/DriverTimeOff"
											)
										}
									}
								}
							}
						},

						yardTrucks: {
							path: "/yard/trucks",
							meta: {
								auth: "browse_yard_trucks",
								bcText: "Trucks"
							},
							component: () => import(
								/* webpackChunkName: "YardTrucks" */
								"@/pages/Front/Yard/Trucks"
							),
							children: {
								yardTruckAdd: {
									path: "/yard/trucks/add",
									meta: {
										auth: "add_yard_trucks",
										bcText: "Add a Truck"
									},
									component: () => import(
										/* webpackChunkName: "YardTruck" */
										"@/pages/Front/Yard/Trucks/Truck"
									)
								},

								yardTruck: {
									path: "/yard/trucks/:idTruck",
									props: route => ( { idTruck: parseInt( route.params.idTruck ) } ),
									meta: {
										auth: [
											"read_yard_trucks",
											"edit_yard_trucks"
										],
										bcFetch: params => ( {
											id: params.idTruck,
											property: "name",
											route: "truck"
										} ),
										bcText: truck => truck.name
									},
									component: () => import(
										/* webpackChunkName: "YardTruck" */
										"@/pages/Front/Yard/Trucks/Truck"
									),
									children: {
										yardTruckPreTrips: {
											path: "/yard/trucks/:idTruck/pre-trips",
											meta: {
												auth: "browse_yard_pre_trips",
												bcText: "Pre-Trips"
											},
											props: route => ( { idTruck: parseInt( route.params.idTruck ) } ),
											component: () => import(
												/* webpackChunkName: "YardPreTrips" */
												"@/pages/Front/Yard/Trucks/PreTrips"
											),
											children: {
												yardTruckPreTripAdd: {
													path: "/yard/trucks/:idTruck/pre-trips/add",
													meta: {
														auth: "add_yard_pre_trips",
														bcText: "Add a Pre-Trip"
													},
													props: route => ( { idTruck: parseInt( route.params.idTruck ) } ),
													component: () => import(
														/* webpackChunkName: "YardPreTrip" */
														"@/pages/Front/Yard/Trucks/PreTrips/PreTrip"
													)
												},

												yardTruckPreTrip: {
													path: "/yard/trucks/:idTruck/pre-trips/:idPreTrip",
													meta: {
														auth: [
															"read_yard_pre_trips",
															"edit_yard_pre_trips"
														],
														bcText: "View Pre-Trip"
													},
													props: route => ( {
														idTruck: parseInt( route.params.idTruck ),
														idPreTrip: parseInt( route.params.idPreTrip )
													} ),
													component: () => import(
														/* webpackChunkName: "YardPreTrip" */
														"@/pages/Front/Yard/Trucks/PreTrips/PreTrip"
													)
												}
											}
										}
									}
								}
							}
						},

						yardSchedules: {
							path: "/yard/schedules",
							meta: {
								auth: "browse_yard_schedules",
								bcText: "Schedules"
							},
							component: () => import(
								/* webpackChunkName: "YardSchedules" */
								"@/pages/Front/Yard/Schedules"
							),
							children: {
								yardScheduleAdd: {
									path: "/yard/schedules/add",
									meta: {
										auth: "add_yard_schedules",
										bcText: "Add a Schedule"
									},
									component: () => import(
										/* webpackChunkName: "YardSchedule" */
										"@/pages/Front/Yard/Schedules/Schedule"
									)
								},

								yardScheduleRequest: {
									path: "/yard/schedules/request",
									meta: {
										auth: "read_yard_schedules",
										bcText: "Request a Schedule"
									},
									component: () => import(
										/* webpackChunkName: "YardSchedule" */
										"@/pages/Front/Yard/Schedules/Schedule"
									)
								},

								yardScheduleRequests: {
									path: "/yard/schedules/requests",
									meta: {
										auth: "add_yard_schedules",
										bcText: "Schedule Requests"
									},
									component: () => import(
										/* webpackChunkName: "YardScheduleRequests" */
										"@/pages/Front/Yard/Schedules/Requests"
									)
								},

								yardSchedule: {
									path: "/yard/schedules/:idSchedule",
									props: route => ( { idSchedule: parseInt( route.params.idSchedule ) } ),
									meta: {
										auth: [
											"read_yard_schedules",
											"edit_yard_schedules"
										],
										bcText: "Edit Schedule"
									},
									component: () => import(
										/* webpackChunkName: "YardSchedule" */
										"@/pages/Front/Yard/Schedules/Schedule"
									)
								}
							}
						},

						yardTrips: {
							path: "/yard/trips",
							meta: {
								auth: "browse_yard_trips",
								bcText: "Trips"
							},
							component: () => import(
								/* webpackChunkName: "YardTrips" */
								"@/pages/Front/Yard/Trips"
							),
							children: {
								yardTripAdd: {
									path: "/yard/trips/add",
									meta: {
										auth: "add_yard_trips",
										bcText: "Add a Trip"
									},
									component: () => import(
										/* webpackChunkName: "YardTrip" */
										"@/pages/Front/Yard/Trips/Trip"
									)
								},

								yardTrip: {
									path: "/yard/trips/:idTrip",
									props: route => ( { idTrip: parseInt( route.params.idTrip ) } ),
									meta: {
										auth: [
											"read_yard_trips",
											"edit_yard_trips"
										],
										bcText: "Edit Trip"
									},
									component: () => import(
										/* webpackChunkName: "YardTrip" */
										"@/pages/Front/Yard/Trips/Trip"
									),
									children: {
										yardTripDeliveryNote: {
											path: "/yard/trips/:idTrip/delivery-note",
											meta: {
												auth: [
													"read_yard_trips",
													"edit_yard_trips"
												],
												bcText: "Trip Delivery Note"
											},
											props: route => ( { idTrip: parseInt( route.params.idTrip ) } ),
											component: () => import(
												/* webpackChunkName: "YardTripDeliveryNote" */
												"@/pages/Front/Yard/Trips/DeliveryNote"
											)
										},

										yardTripErrorAdd: {
											path: "/yard/trips/:idTrip/errors/add",
											meta: {
												auth: "add_yard_trip_errors",
												bcText: "Add an Error"
											},
											props: route => ( { idTrip: parseInt( route.params.idTrip ) } ),
											component: () => import(
												/* webpackChunkName: "YardTripError" */
												"@/pages/Front/Yard/Trips/TripError"
											)
										},

										yardTripError: {
											path: "/yard/trips/:idTrip/errors/:idError",
											meta: {
												auth: [
													"read_yard_trip_errors",
													"edit_yard_trip_errors"
												],
												bcText: "Edit Error"
											},
											props: route => ( {
												idTrip: parseInt( route.params.idTrip ),
												idError: parseInt( route.params.idError )
											} ),
											component: () => import(
												/* webpackChunkName: "YardTripError" */
												"@/pages/Front/Yard/Trips/TripError"
											)
										}
									}
								}
							}
						},

						yardHub: {
							path: "/yard/hub",
							meta: {
								auth: "read_yard_hub",
								bcText: "Hub"
							},
							component: () => import(
								/* webpackChunkName: "YardHub" */
								"@/pages/Front/Yard/Hub"
							)
						},

						yardHubKiosk: {
							path: "/yard/hub/kiosk",
							meta: { auth: null },
							props: { kiosk: true },
							component: () => import(
								/* webpackChunkName: "YardHub" */
								"@/pages/Front/Yard/Hub"
							)
						}
					}
				},

				safety: {
					path: "/safety",
					meta: { bcText: "Safety" },
					component: () => import(
						/* webpackChunkName: "Safety" */
						"@/pages/Front/Safety"
					),
					children: {
						safetyAccidents: {
							path: "/safety/accidents",
							meta: {
								auth: "browse_safety_accident_reports",
								bcText: "Accident / Incident Reports"
							},
							component: () => import(
								/* webpackChunkName: "SafetyAccidents" */
								"@/pages/Front/Safety/Accidents"
							)
						},

						safetyEmployeeInjuries: {
							path: "/safety/employee-injury-reports",
							meta: {
								auth: "browse_safety_employee_injury_reports",
								bcText: "Employee Injury Reports"
							},
							component: () => import(
								/* webpackChunkName: "SafetyInjuries" */
								"@/pages/Front/Safety/Injuries"
							),
							children: {
								safetyEmployeeInjuryAdd: {
									path: "/safety/employee-injury-reports/add",
									meta: {
										auth: "add_safety_employee_injury_reports",
										bcText: "File Injury Report"
									},
									component: () => import(
										/* webpackChunkName: "SafetyInjury" */
										"@/pages/Front/Safety/Injuries/EmployeeInjuryReport"
									)
								},

								safetyEmployeeInjury: {
									path: "/safety/employee-injury-reports/:idReport",
									meta: {
										auth: [
											"read_safety_employee_injury_reports",
											"edit_safety_employee_injury_reports"
										],
										bcText: "Edit Injury Report"
									},
									props: route => ( {
										idReport: parseInt( route.params.idReport )
									} ),
									component: () => import(
										/* webpackChunkName: "SafetyInjury" */
										"@/pages/Front/Safety/Injuries/EmployeeInjuryReport"
									)
								}
							}
						},

						safetyNearMisses: {
							path: "/safety/near-miss-reports",
							meta: {
								auth: "browse_safety_near_miss_reports",
								bcText: "Near Miss Reports"
							},
							component: () => import(
								/* webpackChunkName: "SafetyNearMisses" */
								"@/pages/Front/Safety/NearMisses"
							),
							children: {
								safetyNearMissAdd: {
									path: "/safety/near-miss-reports/add",
									meta: {
										auth: "add_safety_near_miss_reports",
										bcText: "File Near Miss Report"
									},
									component: () => import(
										/* webpackChunkName: "SafetyNearMiss" */
										"@/pages/Front/Safety/NearMisses/NearMissReport"
									)
								},

								safetyNearMiss: {
									path: "/safety/near-miss-reports/:idReport",
									meta: {
										auth: [
											"read_safety_near_miss_reports",
											"edit_safety_near_miss_reports"
										],
										bcText: "Edit Near Miss Report"
									},
									props: route => ( {
										idReport: parseInt( route.params.idReport )
									} ),
									component: () => import(
										/* webpackChunkName: "SafetyNearMiss" */
										"@/pages/Front/Safety/NearMisses/NearMissReport"
									)
								}
							}
						}
					}
				},

				serviceCenter: {
					path: "/service-center",
					meta: { bcText: "Service Center" },
					component: () => import(
						/* webpackChunkName: "ServiceCenter" */
						"@/pages/Front/ServiceCenter"
					),
					children: {
						serviceMap: {
							path: "/service-center/map",
							meta: {
								auth: "browse_services",
								bcText: "Service Map"
							},
							component: () => import(
								/* webpackChunkName: "ServiceMap" */
								"@/pages/Front/ServiceCenter/ServiceMap"
							)
						},

						serviceAdd: {
							path: "/service-center/services/add",
							meta: {
								auth: "add_services",
								bcText: "Add a Service"
							},
							component: () => import(
								/* webpackChunkName: "Service" */
								"@/pages/Front/ServiceCenter/Service"
							)
						},

						service: {
							path: "/service-center/services/:idService",
							props: route => ( { idService: parseInt( route.params.idService ) } ),
							meta: {
								auth: [
									"read_services",
									"edit_services"
								],
								bcFetch: params => ( {
									id: params.idService,
									property: "name",
									route: "service"
								} ),
								bcText: service => service.name
							},
							component: () => import(
								/* webpackChunkName: "Service" */
								"@/pages/Front/ServiceCenter/Service"
							)
						},

						serviceTypes: {
							path: "/service-center/statuses",
							meta: {
								auth: "browse_service_types",
								bcText: "Service Status Types"
							},
							component: () => import(
								/* webpackChunkName: "ServiceTypes" */
								"@/pages/Front/ServiceCenter/ServiceTypes"
							),
							children: {
								serviceTypeAdd: {
									path: "/service-center/statuses/add",
									meta: {
										auth: "add_service_types",
										bcText: "Add Service Status Type"
									},
									component: () => import(
										/* webpackChunkName: "ServiceType" */
										"@/pages/Front/ServiceCenter/ServiceType"
									)
								},

								serviceType: {
									path: "/service-center/statuses/:idServiceType",
									props: route => ( { idServiceType: parseInt( route.params.idServiceType ) } ),
									meta: {
										auth: [
											"read_service_types",
											"edit_service_types"
										],
										bcFetch: params => ( {
											id: params.idServiceType,
											property: "name",
											route: "serviceType"
										} ),
										bcText: serviceType => serviceType.name
									},
									component: () => import(
										/* webpackChunkName: "ServiceType" */
										"@/pages/Front/ServiceCenter/ServiceType"
									)
								}
							}
						}
					}
				}
			}
		}
	}
};
